import { ApiRequest, ApiRequestNoLoder } from "../../services/api"

export const PostGeneratePrompt = async (data) => {
    return await ApiRequest("PUT", "generate-prompt-payload", data)
}

export const PostTradinessData = async (data) => {
    return await ApiRequest("POST", "admin/tradiness-notice", data)
}
export const PostScheduledData = async (data) => {
    return await ApiRequest("POST", "admin/scheduled-request", data)
}
export const PostRequestOtp = async (data) => {
    return await ApiRequest("POST", "admin/request-otp", data)
}
export const PostVerifyOtp = async (data) => {
    return await ApiRequest("POST", "admin/verify-otp", data)
}

export const PostUploadProfile = async (data) => {
    return await ApiRequest("POST", "upload-profile", data, {
        "Content-Type": "multipart/form-data",
    })
}
export const PostScreenshots = async (data) => {
    return await ApiRequest("POST", "upload-screenshots", data, {
        "Content-Type": "multipart/form-data",
    })
}
